import type { FC, PropsWithChildren } from 'react'
import type { FlexProps } from 'antd'

import {
  SC_Flex,
} from './styled'

export type T_FlexProps = FlexProps

export const Flex: FC<PropsWithChildren<T_FlexProps>> = (props) => {
  const { children, ...restProps } = props

  return (
    <SC_Flex {...restProps}>
      {children}
    </SC_Flex>
  )
}
